import Header from '../../components/Header'
import HeaderImage from '../../Imagenes/INSTALACIONES/DSC_3273.jpg'
import ImageSala1 from '../../Imagenes/página web/SALAS QUITO NORTE/SALA 1/sala1.jpg'
import ImageSala12 from '../../Imagenes/página web/SALAS QUITO NORTE/SALA 1/sala11.jpg'
import ImageSala13 from '../../Imagenes/página web/SALAS QUITO NORTE/SALA 1/sala12.jpg'
import ImageSala14 from '../../Imagenes/página web/SALAS QUITO NORTE/SALA 1/sala13.jpg'
import ImageSala2 from '../../Imagenes/página web/SALAS QUITO NORTE/SALA 2/sala 2.jpg'
import ImageSala23 from '../../Imagenes/página web/SALAS QUITO NORTE/SALA 2/sala 21.jpg'
import ImageSala24 from '../../Imagenes/página web/SALAS QUITO NORTE/SALA 2/sala 23.jpg'
import ImageSala3 from '../../Imagenes/página web/SALAS QUITO NORTE/SALA 3/sala 3.jpg'
import ImageSala32 from '../../Imagenes/página web/SALAS QUITO NORTE/SALA 3/sala 31.jpg'
import ImageSala33 from '../../Imagenes/página web/SALAS QUITO NORTE/SALA 3/sala 32.jpg'
import ImageSala35 from '../../Imagenes/página web/SALAS QUITO NORTE/SALA 3/sala 33.jpg'
import ImageSala4 from '../../Imagenes/página web/SALAS QUITO NORTE/SALA 4/sala 4.jpg'
import ImageSala43 from '../../Imagenes/página web/SALAS QUITO NORTE/SALA 4/sala 41.jpg'
import ImageSala45 from '../../Imagenes/página web/SALAS QUITO NORTE/SALA 4/sala 42.jpg'
import SalaCard from "../../components/SalaCard";
import React, { useEffect } from 'react';
import './wakeRooms.css'

const WakeRooms = () => {

  useEffect(() => { /*Para ver desde el principio de la página */
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="roomsq-page">

       {/* HEADER */}
      <Header
        title="Salas de Velación Quito"
        image={HeaderImage}
      >
         Contamos con 2 salas vip y 2 salas premium con capacidad para 80 y 120 personas y nuestras instalaciones también cuenta con Capilla. 
      </Header>
 
      <section className="wake-room">
      <SalaCard
      title="Sala 1 VIP"
      description="Capacidad para 80 personas · Cafetería · Sala de estar · Baños privados · Transmisión virtual · WIFI"
      images={[ImageSala1, ImageSala12, ImageSala13, ImageSala14]}
      />

      <SalaCard
      title="Sala 2 VIP"
      description="Capacidad para 80 personas · Cafetería · WIFI · Seguridad privada"
      images={[ImageSala2, ImageSala23, ImageSala24]}
       />

       <SalaCard
      title="Sala 3 Premium"
      description="Capacidad para 120 personas · Espacios amplios · Transmisión en vivo"
      images={[ImageSala3, ImageSala32, ImageSala33, ImageSala35]}
       />

      <SalaCard
      title="Sala 4 Premium"
      description="Capacidad para 120 personas · Capilla · Seguridad privada"
      images={[ImageSala4, ImageSala43, ImageSala45]}
     />


      </section>
    
    </main>
    
  )
}

export default WakeRooms
